// extracted by mini-css-extract-plugin
export var fullHeightState = "_4x-7";
export var headerCell = "_4x-1";
export var loadingStateCell = "_4x-4";
export var rowWrapper = "_4x-3";
export var standaloneTable = "_4x-8";
export var standaloneTableWithBodyFill = "_4x-9";
export var stateCell = "_4x-5";
export var table = "_4x-0";
export var tableBodyFiller = "_4x-6";
export var white = "_4x-2";